<template>

    <div class="credit-proposal-information-component">

        <!-- Introduction -->
        <div class="introduction">
            <div class="row">
                <div class="col-12">
                    <h3>{{ sectionThreeHeading }}</h3>
                    <div v-html="description"></div>
                </div>
            </div>
        </div>


        <div v-if="quote" class="financial-details">

            <div class="row">
                <div class="col-12">

                    <h3>{{ schemeCostTitle }}</h3>

                    <div>
                        <div class="">
                            <span class="key">Contract Term</span>
                            <span class="ms-2 value">
                                <strong>{{ term }} Months</strong>
                            </span>
                        </div>
                        <div class="">
                            <span class="key">Mileage</span>
                            <span class="ms-2 value">
                                <strong>{{ annualMileage }}</strong>
                            </span>
                        </div>
                        <div class="">
                            <span class="key">Gross Monthly Sacrifice</span>
                            <span class="ms-2 value">
                                <strong>{{ quoteCosts.gross_monthly_sacrifice }}</strong>
                            </span>
                        </div>
                    </div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_1" id="confirm_1"
                               v-model="confirmations.schemeCostDetails" class="confirm">
                        <label for="confirm_1">
                            {{ schemeCostDeclaration }}
                        </label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ maintenanceTitle }}</h3>
                    <p>{{ maintenanceDescription }}</p>

                    <h4>{{ maintenanceKeyPointsHeading }}</h4>
                    <div v-html="maintenanceKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_3" id="confirm_3"
                               v-model="confirmations.fullVehicleMaintenance" class="confirm">
                        <label for="confirm_3">{{ maintenanceDeclarationText }}</label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ insuranceAccidentDamageTitle }}</h3>
                    <p>{{ insuranceAccidentDamageDescription }}</p>

                    <h4>{{ insuranceAccidentDamageKeyPointsHeading }}</h4>
                    <div v-html="insuranceAccidentDamageKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_4" id="confirm_4"
                               v-model="confirmations.motorInsuranceProduct" class="confirm">
                        <label for="confirm_4">{{ insuranceAccidentDamageDeclarationText }}</label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ schemePolicyTitle }}</h3>
                    <p>{{ schemePolicyDescription }}</p>

                    <h4>{{ schemePolicyKeyPointsHeading }}</h4>
                    <div v-html="schemePolicyKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_5" id="confirm_5"
                               v-model="confirmations.schemePolicy" class="confirm">
                        <label for="confirm_5">{{ schemePolicyDeclarationText }}</label>
                    </div>

                </div>
            </div>

            <div v-if="quote && policies" class="financial-details">
              <template v-for="(policy, index) in policies">
                <div class="row">
                  <div class="col-12">

                    <h3>{{ policy.title }}</h3>
                    <p>{{ policy.description }}</p>

                    <h4>{{ policy.key_points_heading }}</h4>
                    <div v-html="policy.key_points"></div>

                    <div class="agree mb-0" v-if="policy.declaration_required === '1'">
                      <input type="checkbox" name="confirm_2" v-bind:id="'confirm_'+index"
                        v-model="confirmations[stringToKey(policy.title)]" class="confirm">
                      <label v-bind:for="'confirm_'+index">{{ policy.declaration_text }}</label>
                    </div>

                  </div>
                </div>
              </template>

            </div>

        </div>
    </div>

</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {

    props: [
        'session',
        'submit-order',
        'confirmations',
        'quote',
        'quoteCosts',
        'driverProfile',
        'adminPortalData',
        'sectionThreeHeading',
        'currentProduct',
    ],

    data: () => {
        return {};
    },

    methods: {
        stringToKey(string) {
            return string.replace(/\ /g, '_');
        },
        getInCurrency(value, currency = '£') {
            return currency + Number(value).toFixed(2);
        },
    },

    computed: {
        policies() {
            return this.currentProduct.order_stage_three_policies;

        },
        term() {
            if (this.quote.term !== undefined) {
                return this.quote.term;
            }
            return this.quote.definition.plan.term;
        },
        annualMileage() {
            return this.quote?.definition?.plan?.annualDistance;
        },
        insurance() {
          return this.getInCurrency(Number(this.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_InsuranceCost) / Number(this.quote.definition.plan.term));
        },
        vehiclePayment() {
            return this.getInCurrency(Number(this.quote.details.pricing.totalIncVAT).toFixed(2));
        },
        description() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_section_three_description : '';
        },
        schemeCostTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_cost_title : '';
        },
        schemeCostDeclaration() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_cost_declaration : '';
        },
        insuranceAccidentDamageDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_insurance_accident_damage_declaration_text : '';
        },
        insuranceAccidentDamageDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_insurance_accident_damage_description : '';
        },
        insuranceAccidentDamageKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_insurance_accident_damage_key_points : '';
        },
        insuranceAccidentDamageKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_insurance_accident_damage_key_points_heading : '';
        },
        insuranceAccidentDamageTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_insurance_accident_damage_title : '';
        },
        maintenanceDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_maintenance_declaration_text : '';
        },
        maintenanceDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_maintenance_description : '';
        },
        maintenanceKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_maintenance_key_points : '';
        },
        maintenanceKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_maintenance_key_points_heading : '';
        },
        maintenanceTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_maintenance_title : '';
        },
        // salaryDeductionsDeclaration() {
        //     return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_salary_deductions_declaration : '';
        // },
        // salaryDeductionsDescription() {
        //     return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_salary_deductions_description : '';
        // },
        // salaryDeductionsTitle() {
        //     return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_salary_deductions_title : '';
        // },
        schemePolicyDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_policy_declaration_text : '';
        },
        schemePolicyDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_policy_description : '';
        },
        schemePolicyKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_policy_key_points : '';
        },
        schemePolicyKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_policy_key_points_heading : '';
        },
        schemePolicyTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_scheme_policy_title : '';
        },
        sectionThreeDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_section_three_description : '';
        },
        sectionThreeTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_three_section_three_title : '';
        },
    },
    watch: {
        confirmations: {
            handler(confirmations) {
              EventBus.$emit('setConfirmations', confirmations);
            },
            deep: true,
        },
    },
};
</script>


